import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_mst_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  price_json?: {};
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  plm_display_text: fromDatatype.VarcharDatatypeInterface;
  plm_process_status_guid: fromDatatype.GuidDataFieldInterface;
  plm_process_status_code: fromDatatype.VarcharDatatypeInterface;
  plm_process_template_guid: fromDatatype.GuidDataFieldInterface;
  plm_process_type: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_3: fromDatatype.TextDatatypeInterface;
  additional_remarks_4: fromDatatype.TextDatatypeInterface;
}

export class bl_inv_mst_item_hdr_RowClass
  implements bl_inv_mst_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  price_json?: {};
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  plm_display_text: fromDatatype.VarcharDatatypeInterface;
  plm_process_status_guid: fromDatatype.GuidDataFieldInterface;
  plm_process_status_code: fromDatatype.VarcharDatatypeInterface;
  plm_process_template_guid: fromDatatype.GuidDataFieldInterface;
  plm_process_type: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_3: fromDatatype.TextDatatypeInterface;
  additional_remarks_4: fromDatatype.TextDatatypeInterface;
}